import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { TID } from "@/lib/testIds";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refreshWorkspace, refreshBrand } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    // Clear the fragment ASAP
    window.history.replaceState({}, "", window.location.pathname + window.location.search);

    (async () => {
      try {
        const resp = await api.post("/auth/session", { session_id: sessionId });
        setUser(resp.data.user);
        // IMPORTANT: refreshBrand too — AuthContext.brand starts null and its
        // initial checkAuth is skipped when a session_id hash is present, so
        // downstream screens (Dashboard/WelcomeCard) would otherwise see a
        // stale null brand until a full page reload.
        await Promise.all([refreshWorkspace(), refreshBrand()]);
        navigate("/app/find-customers", { replace: true, state: { user: resp.data.user } });
      } catch (e) {
        console.error("Auth callback failed:", e);
        navigate("/login?error=session_failed", { replace: true });
      }
    })();
  }, [navigate, setUser, refreshWorkspace, refreshBrand]);

  return (
    <div
      data-testid={TID.authCallbackLoading}
      className="min-h-screen flex items-center justify-center bg-lm-bg"
    >
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-lm-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <div className="text-lm-text2">Signing you in…</div>
      </div>
    </div>
  );
}
